import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilesService } from './files.service';
import { FilesViewModel } from './filesView.model';

export interface MoveDialogData {
  originUid: string;
  isCopy: boolean;
  currentPath: string;
}

interface BreadcrumbItem {
  label: string;
  path: string;
}

@Component({
    selector: 'convfact-files-move-dialog',
    templateUrl: './files-dialog-move.component.html',
    styleUrls: ['./files-dialog-move.component.css'],
    standalone: false
})
export class FilesDialogMoveComponent implements OnInit {

  dataSource: FilesViewModel = new FilesViewModel();
  path: string;
  loading = false;
  breadcrumbs: BreadcrumbItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MoveDialogData,
    private dialogRef: MatDialogRef<FilesDialogMoveComponent>,
    private filesService: FilesService
  ) { }

  ngOnInit(): void {
    this.path = 'files';
    this.breadcrumbs = [{ label: 'Inicio', path: 'files' }];
    this.loadDirectories();
  }

  loadDirectories(): void {
    this.loading = true;
    // Usamos this.path en lugar de 'files' hardcodeado
    this.filesService.getList(this.path, false, false, false, 1)
      .then(result => {
        this.dataSource.files = result.files.filter(f =>
          f.isDirectory && f.uid !== this.data.originUid  // excluimos el propio directorio origen
        );
      })
      .finally(() => this.loading = false);
  }

  goToDirectory(dir: { note: string, name: string }): void {
    this.path = this.path + '/' + dir.note;
    this.breadcrumbs.push({ label: dir.note, path: this.path });
    this.loadDirectories();
  }

  navigateTo(crumb: BreadcrumbItem): void {
    this.path = crumb.path;
    // Recortamos breadcrumbs hasta el elemento pulsado
    const index = this.breadcrumbs.findIndex(b => b.path === crumb.path);
    this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
    this.loadDirectories();
  }

  goBack(): void {
    if (this.breadcrumbs.length <= 1) return;
    this.breadcrumbs.pop();
    const previous = this.breadcrumbs[this.breadcrumbs.length - 1];
    this.path = previous.path;
    this.loadDirectories();
  }

  selectHere(): void {
    this.dialogRef.close(this.path);
  }

  moveToRoot(): void {
    this.dialogRef.close('files');
  }

  cancel(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}